import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const ContainerDashboardMatrix = styled.section.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  position: relative;
  width: 100%;
  height: 100%;

  overflow-y: auto;

  ${VerticalStyledScrollBar}
`

export const ContainerRow = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
`

export const ContainerRowUncontrolled = styled.div`
  height: 80px;
  display: flex;
  gap: 17px;
  align-items: center;
`

export const FixedContainerHealthProcedure = styled.div`
  position: relative;
  width: 45px;
  height: 45px;
`

interface VerticalLineProps {
  isFirst: boolean
  isLast: boolean
}

export const VerticalLine = styled.div<VerticalLineProps>`
  position: absolute;
  ${props => (props.isFirst ? `bottom: 0;` : `top: 0;`)}
  left: 50%;
  width: 1px;
  height: ${props => (props.isFirst || props.isLast ? '50%' : '100%')};
  transform: translateX(-50%);

  background: ${props => props.theme.colors.color378ff7};
`

export const ContainerEllipseAccordion = styled.div`
  display: flex;
  flex-direction: row;
`
